import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useActiveContextReady } from './useActiveContextReady';
import { config } from '../config';

export interface TeamMember {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
}

interface TeamMembersResponse {
  members: TeamMember[];
}

const backendApi = config.backendApi;

const fetchTeamMembers = async (teamId: string): Promise<TeamMember[]> => {
  const response = await axios.get<TeamMembersResponse>(
    `${backendApi}/api/teams/${teamId}/members`,
    { withCredentials: true }
  );
  return response.data.members;
};

export function useTeamMembers(teamId: string | null | undefined) {
  const contextReady = useActiveContextReady();

  return useQuery<TeamMember[]>({
    queryKey: ['team-members', teamId],
    queryFn: () => {
      if (!teamId) {
        throw new Error("teamId is required to fetch team members.");
      }
      return fetchTeamMembers(teamId);
    },
    enabled: !!teamId && contextReady,
  });
}
